(function() {
    'use strict';

    angular.module( APP_ID )
        .factory( 'ToolkitTracker', [ '$window', 'LoggerFactory', ToolkitTrackerService ]);



    //TODO: Should probably be in the `ServiceProvider`
    var tracker = window.toolkitTracker ? window.toolkitTracker({
        autoRegister: false, // Don't auto-track in Angular.js
    }) : function () {};



    /**
     * Exposes Toolkit's tracking API to the Angular.js
     * (Documentation: https://static.victoria.ac.nz/components.html#tracking-api-for-gtm)
     *
     * @param {ng.IWindowService} $window
     * @param {LoggerService} LoggerFactory
     *
     * @returns {ToolkitTracker}
     */
    function ToolkitTrackerService( $window, LoggerFactory ){


        // Check the dependency and report if not available
        if ( !$window.toolkitTracker ) {
            /** @type {Logger} */
            var logger = LoggerFactory.createLogger( 'ToolkitTracker', false );
            logger.warn( "Cannot load Toolkit's tracking utility to use it for Google Tag Manager's custom events tracking!" );
        }



        ////////////////////////////////////////////////////////////////////

        return tracker; // Expose API

        ////////////////////////////////////////////////////////////////////



    }
})();
